import React, { useState, useEffect } from 'react'

const AIAssistant = ({ alerts = [], collisionAlerts = [] }) => {
  const [messages, setMessages] = useState([])
  const [isMinimized, setIsMinimized] = useState(false)

  useEffect(() => {
    setMessages([
      {
        id: 1,
        type: 'ai',
        text: "Hello! I'm your SafeNav assistant 🌟 I'll monitor your route and alert you to potential risks.",
        timestamp: new Date()
      }
    ])
  }, [])

  useEffect(() => {
    if (collisionAlerts.length > 0) {
      const latest = collisionAlerts[collisionAlerts.length - 1]
      if (latest.collisions?.[0]) {
        const msg = latest.collisions[0].message + (latest.sensorEnhanced ? ' (Sensor Enhanced)' : '')
        addMessage(msg)
      }
    }
  }, [collisionAlerts])

  useEffect(() => {
    if (alerts.length > 0) {
      const latest = alerts[alerts.length - 1]
      if (latest.type === 'trip_started' || latest.type === 'trip_ended') {
        addMessage(latest.message)
      }
    }
  }, [alerts])

  const addMessage = (text) => {
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'ai',
      text,
      timestamp: new Date()
    }])
  }

  if (isMinimized) {
    return (
      <button
        onClick={() => setIsMinimized(false)}
        className="fixed bottom-4 right-4 bg-green-600 text-white p-3 rounded-full shadow-lg hover:bg-green-700 z-50"
      >
        <span className="text-lg">🤖</span>
      </button>
    )
  }

  return (
    <div className="bg-white rounded-lg shadow-lg border max-w-md ml-auto">
      <div className="bg-green-600 text-white p-4 rounded-t-lg flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <span className="text-lg">🤖</span>
          <div>
            <h3 className="font-semibold">SafeNav Assistant</h3>
            <p className="text-green-100 text-sm">Always here to help!</p>
          </div>
        </div>
        <button onClick={() => setIsMinimized(true)} className="text-green-100 hover:text-white">
          −
        </button>
      </div>
      <div className="h-48 overflow-y-auto p-4 space-y-3">
        {messages.map((msg) => (
          <div key={msg.id} className="flex justify-start">
            <div className="max-w-[80%] rounded-lg p-3 bg-green-50 text-gray-800 border border-green-100">
              <p className="text-sm">{msg.text}</p>
              <p className="text-xs text-gray-500 mt-1">{msg.timestamp.toLocaleTimeString()}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AIAssistant